// removed by extract-text-webpack-plugin
module.exports = {"tabActiveButton":"_34vwr","tabInactiveButton":"DIIoO","base":"_3JjCc","secondary":"_30WuK","flat":"_3T7Qy","disabled":"HrQcl","hide":"_2V1f1","mini":"zMG9n"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Button/Button.scss
// module id = 1883
// module chunks = 0